module.exports = __webpack_public_path__ + "img/add_row_after.a6ae1d8a.svg";